function s(t, n, a) {
  const e = new CustomEvent(n, {
    bubbles: !0,
    cancelable: !1,
    detail: {},
    ...a
  });
  return t.dispatchEvent(e), e;
}
export {
  s as e
};
